"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplaySubHomeResponseSchema = exports.DisplayHomeResponseSchema = exports.HomeResponseSchema = exports.HomeNavigationBarDataSchema = exports.HomeSearchBarDataSchema = exports.HomeCompanyScheme = exports.HomeWidgetItemScheme = exports.HomeWidgetItemDataScheme = exports.HomeInputScheme = exports.MemberClass = exports.RefreshPolicy = void 0;
var zod_1 = require("zod");
var journey_1 = require("../journey");
var member_1 = require("../member");
var widgets_1 = require("./widgets");
exports.RefreshPolicy = {
    ON_REQUEST: 'ON_REQUEST',
    ON_VISIBLE: 'ON_VISIBLE',
};
exports.MemberClass = {
    LEVEL_00: 'LEVEL_00',
    LEVEL_01: 'LEVEL_01',
    LEVEL_01_TRIAL: 'LEVEL_01_TRIAL',
    MEMBER_CLASS_CODE: 'MEMBER_CLASS_CODE',
};
exports.HomeInputScheme = zod_1.z.object({
    userLocation: zod_1.z
        .object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
        locationType: zod_1.z.string(),
        locationTime: zod_1.z.number(),
    })
        .optional(),
    localAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string(),
        checkOutDate: zod_1.z.string(),
        capacityAdults: zod_1.z.number(),
        childrenAges: zod_1.z.array(zod_1.z.number()),
    }),
    globalAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string(),
        checkOutDate: zod_1.z.string(),
        rooms: zod_1.z.array(zod_1.z.object({
            capacityAdults: zod_1.z.number(),
            childrenAges: zod_1.z.array(zod_1.z.number()),
        })),
    }),
});
exports.HomeWidgetItemDataScheme = zod_1.z.union([
    widgets_1.BusinessQuickCategoryWidgetDataSchema,
    widgets_1.CuratedLiveSplitpaneWidgetDataSchema,
    widgets_1.PromotionWideBannerWidgetDataSchema,
    widgets_1.RecentProductWidgetDataSchema,
    widgets_1.TopRatedProductRankingWidgetDataSchema,
    widgets_1.ExhibitionProductWidgetDataSchema,
    widgets_1.BenefitQuickCategoryWidgetDataSchema,
    widgets_1.RegionalFilteredGalleryRankingWidgetDataSchema,
    widgets_1.TriplePlanEntryWidgetDataSchema,
    zod_1.z.unknown(),
]);
exports.HomeWidgetItemScheme = zod_1.z.object({
    type: zod_1.z.string(),
    target: zod_1.z.string(),
    refreshPolicy: zod_1.z.nativeEnum(exports.RefreshPolicy),
    api: zod_1.z.object({ method: zod_1.z.string(), url: zod_1.z.string() }),
    data: exports.HomeWidgetItemDataScheme,
    // TODO: api 에서 converter 를 거친 data 로 타입 정의 필요
    converted: zod_1.z.unknown().optional(),
});
exports.HomeCompanyScheme = zod_1.z.object({
    basic: zod_1.z.object({ name: zod_1.z.string(), ceo: zod_1.z.string() }),
    location: zod_1.z.object({
        address: zod_1.z.string(),
        lat: zod_1.z.number(),
        lng: zod_1.z.number(),
        url: zod_1.z.string(),
    }),
    registration: zod_1.z.object({
        license: zod_1.z.string(),
        seller: zod_1.z.string(),
        tour: zod_1.z.string(),
        licenseLink: zod_1.z.string(),
    }),
    service: zod_1.z.object({
        provider: zod_1.z.string(),
        privacyLink: zod_1.z.string(),
        conditionLink: zod_1.z.string(),
        youthLink: zod_1.z.string(),
        eFinanceTermLink: zod_1.z.string(),
        eFinanceUserGuidelineLink: zod_1.z.string(),
        contentsLawLink: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
        mailOrderSalesInfo: zod_1.z.string(),
        copyrightInfo: zod_1.z.string(),
        disputeResolutionLink: zod_1.z.string(),
    }),
    helpdesk: zod_1.z.object({ mail: zod_1.z.string(), tel: zod_1.z.string() }),
    isms: zod_1.z.object({ title: zod_1.z.string(), scope: zod_1.z.string(), period: zod_1.z.string() }),
});
exports.HomeSearchBarDataSchema = zod_1.z.object({
    bi: zod_1.z
        .object({
        placeholderImage: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.object({ pc: zod_1.z.string(), mobile: zod_1.z.string() }),
        }),
        transitionImage: zod_1.z.object({
            web: zod_1.z.object({ pc: zod_1.z.string() }),
        }),
        fileUrl: zod_1.z
            .object({
            app: zod_1.z.string(),
            web: zod_1.z.object({ mobile: zod_1.z.string() }),
        })
            .optional(),
        action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    })
        .optional(),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }).optional(),
    placeholder: zod_1.z.string().optional(),
    logMeta: zod_1.z.object({ object: zod_1.z.string(), deusBiId: zod_1.z.string() }).optional(),
});
exports.HomeNavigationBarDataSchema = zod_1.z.object({
    memberClass: zod_1.z
        .enum([
        member_1.MEMBER_CLASS_CODE.LEVEL_00,
        member_1.MEMBER_CLASS_CODE.LEVEL_01,
        member_1.MEMBER_CLASS_CODE.LEVEL_01_TRIAL,
        member_1.MEMBER_CLASS_CODE.LEVEL_01_TRIAL_NERGET,
        member_1.MEMBER_CLASS_CODE.FLIGHT_00,
        member_1.MEMBER_CLASS_CODE.FLIGHT_01,
    ])
        .nullish(),
    cart: zod_1.z.object({ count: zod_1.z.number() }),
    recentProduct: zod_1.z.object({ imageUrl: zod_1.z.string(), webLink: zod_1.z.string() }).optional(),
});
exports.HomeResponseSchema = zod_1.z.object({
    widgets: zod_1.z.array(exports.HomeWidgetItemScheme),
    company: exports.HomeCompanyScheme,
});
exports.DisplayHomeResponseSchema = zod_1.z.object({
    searchBar: exports.HomeSearchBarDataSchema.nullable().optional(),
    navigationBar: exports.HomeNavigationBarDataSchema.nullable().optional(),
    widgets: zod_1.z.array(exports.HomeWidgetItemScheme),
    company: exports.HomeCompanyScheme.nullable().optional(),
    homePopup: journey_1.HomePopupResponseSchema.nullable().optional(), // API 호출 실패 시 null 반환
});
exports.DisplaySubHomeResponseSchema = zod_1.z.object({
    widgets: zod_1.z.array(exports.HomeWidgetItemScheme),
    title: zod_1.z.string(),
});
